import { render } from "./index.vue?vue&type=template&id=18ca3892"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=18ca3892&lang=scss"

import exportComponent from "/Users/tung/Documents/GitHub/cc-faq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__